import axios from "axios";

import {
  ResponseFile,
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {EQUser, userListParams} from "../../models/serverModels/EQUser";

const rootApi = process.env.REACT_APP_API_KEY;

const manager = axios.create({
  baseURL: rootApi,
});

export const getList = async (params: Params.GetList): Promise<ResponseList<EQUser>> =>
  manager({
    url: "/ManagerList",
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<EQUser>> =>
  manager({
    url: `/User/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (params: Params.Create<EQUser>): Promise<ResponseItem<EQUser>> =>
  manager({
    url: `/CompanyManager/`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  manager({
    url: `/User/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (params: Params.Update<EQUser>): Promise<ResponseItem<EQUser>> =>
  manager({
    url: `/CompanyManager/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);
